import { Component, Input, OnDestroy } from '@angular/core';
import { StationGroup } from 'src/tmc-yard/client/model/station-group';
import { StationSet } from 'src/tmc-yard/client/model/station-set';
import { MasterDetailListEntry } from '@sdbn/common';
import { StructureSelectionContext } from '../../../structure-selection.model';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-structure-group-details',
  templateUrl: './structure-group-details.component.html',
  styleUrls: ['./structure-group-details.component.scss']
})
export class StructureGroupDetailsComponent implements OnDestroy {

  selectedStationSet: StationSet = null;
  fixedSelectedStationSet: StationSet = null;

  stationGroup: StationGroup;
  selectionContext: StructureSelectionContext;

  selectionChangeSubscription: Subscription;

  @Input('context') set setSelectionContext(value: StructureSelectionContext) {
    this.selectionContext = value;
    this.selectionChangeSubscription = value.selectionChange$.subscribe(selection => {
      this.updateSelection();
    });
    this.updateSelection();
  }

  @Input('stationGroup') set setStationGroup(stationGroup: StationGroup) {
    this.stationGroup = stationGroup;
    this.updateSelection();
  }

  ngOnDestroy(): void {
    if (this.selectionChangeSubscription != null) {
      this.selectionChangeSubscription.unsubscribe();
      this.selectionChangeSubscription = null;
    }
  }

  updateSelection() {
    if (this.stationGroup != null) {
      if (this.selectionContext != null) {
        const selection = this.selectionContext.selection;
        if (selection.stationSetId != null) {
          for (const stationSet of this.stationGroup.stationSets) {
            if (stationSet.id === selection.stationSetId) {
              if (stationSet.id === this.selectionContext.selection.fixedStationSetId) {
                this.fixedSelectedStationSet = stationSet;
                this.selectedStationSet = stationSet;
              } else {
                this.fixedSelectedStationSet = null;
                this.selectedStationSet = stationSet;
              }
              break;
            }
          }
        } else {
          this.selectedStationSet = null;
        }
      }
    }
  }

  onSelectionChanged(entry: MasterDetailListEntry) {
    const stationSet = entry as StationSet;
    if (stationSet === null) {
      this.selectionContext.setStationSetSelection(null);
    } else {
      this.selectionContext.setStationSetSelection(stationSet.id);
    }
  }

}
